<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="chart-bar" />
          {{ $t('report') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tab">
          <b-tab :title="$t('report')"></b-tab>
          <b-tab :title="$t('history')"></b-tab>
          <b-tab :title="$t('statistical')"></b-tab>
        </b-tabs>
        <translate-report v-if="tab === 0" />
        <history v-else-if="tab === 1" />
        <statistical v-else-if="tab === 2" />
      </div>
    </div>
  </main>
</template>
<script>

import TranslateReport from './TranslateReport.vue'
import History from './History.vue'
import Statistical from './Statistical.vue'

export default {
  components: { TranslateReport, History, Statistical },
  data: function() {
    return {
      tab: 0
    }
  },
  i18n: {
    messages: {
      en: {
        history: 'History',
        report: 'Report',
        statistical: 'Statistical'
      },
      vi: {
        history: 'Lịch sử',
        report: 'Báo cáo',
        statistical: 'Thống kê'
      }
    }
  },
  methods: {}
}
</script>